export interface GroupIdApi {
  groupId: string;
}

export let isGroupIdResponseDTO = (
  variable: unknown
): variable is GroupIdApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "groupId" in variable &&
    typeof variable.groupId === "string"
  );
};
